<script setup lang="ts">
import Button from 'primevue/button';
import DefaultInput from '../components/DefaultInput.vue';
import PasswordInput from '../components/PasswordInput.vue';

import { useLogin } from '../composables/useLogin';

const { handleLogin, form, errors, isPending } = useLogin();
</script>

<template>
  <form
    class="text-bluegray-600 space-y-4 text-center text-sm font-normal"
    @submit.prevent="handleLogin"
  >
    <DefaultInput v-model="form.email" size="small" :error="errors.email">
      Adres e-mail
    </DefaultInput>

    <PasswordInput v-model="form.password" :error="errors.password"> Hasło </PasswordInput>

    <Button
      class="mx-auto"
      type="submit"
      rounded
      :disabled="Object.keys(errors).length > 0 || isPending"
    >
      Zaloguj się
    </Button>
  </form>
</template>
